import React, { useState } from 'react';
import { RouteComponentProps, useHistory, useRouteMatch } from 'react-router-dom';
import { FixedTab, RouteTabs, VariableTab } from '../../components/RouteTabs';
import { useBundlePackages } from '../../hooks/queries/useBundlePackages';
import { IBundlePackage } from '../../services/types';
import { RouteNames } from '../config';
import BundlePackageList from './BundlePackageList';
import BundlePackageView from './BundlePackageView';

interface IProps {}
interface IParamProps {
  storyId?: string;
}

const BundlePackage = (props: IProps & RouteComponentProps): JSX.Element => {
  const path = RouteNames.BundlePackage;

  const match = useRouteMatch<IParamProps>(`${path}/v/:storyId`);
  const storyId = Number(match?.params?.storyId);
  const initialStoryIds = storyId ? [storyId] : [];
  const [editingStoryIds, setEditingStoryIds] = useState<number[]>(initialStoryIds);

  const history = useHistory();
  const { data: bundles } = useBundlePackages();

  const handleRowClick = (bundle: IBundlePackage) => {
    const { storyId } = bundle;

    if (!storyId) {
      return;
    }

    if (!editingStoryIds.find(id => id === storyId)) {
      setEditingStoryIds(ps => [...ps, storyId]);
    }
  };

  const handleCreate = () => {
    history.push(`${RouteNames.BundlePackage}/list`);
  };

  const getTabLabel = (storyId: number) => {
    const bundle = bundles?.find(b => b.storyId === storyId);
    return String(bundle?.story?.title || storyId);
  };

  const getTabUri = (storyId: number) => `v/${storyId}`;

  const handleTabClose = (storyId: number) => {
    setEditingStoryIds(editingStoryIds.filter(id => id !== storyId));
  };

  const keyExtractor = (storyId: number) => `tab-floating-${storyId}`;

  const variableTabRenderer = (storyId: number) => <BundlePackageView storyId={storyId} onCreate={handleCreate} />;

  return (
    <RouteTabs path={path}>
      <FixedTab label="All Bundle Packages" uri="list">
        <BundlePackageList bundles={bundles} onRowClick={handleRowClick} />
      </FixedTab>
      <FixedTab label="Create a bundle package" uri="create">
        <BundlePackageView onCreate={handleCreate} />
      </FixedTab>
      <VariableTab<number>
        data={editingStoryIds}
        label={getTabLabel}
        uri={getTabUri}
        onClose={handleTabClose}
        keyExtractor={keyExtractor}
        render={variableTabRenderer}
      />
    </RouteTabs>
  );
};

export default BundlePackage;
